import { cn } from '../../util';

export function CardTitle({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('text-2xl font-semibold leading-none tracking-tight', className)} {...props} />;
}
